"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EMobileModalType = exports.EDisplayType = exports.EBasketHeaderTypes = exports.EMakeBetStatus = exports.EBetTypes = void 0;
var types_1 = require("../../domain/basket/types");
Object.defineProperty(exports, "EBetTypes", { enumerable: true, get: function () { return types_1.EBetTypes; } });
var EMakeBetStatus;
(function (EMakeBetStatus) {
    EMakeBetStatus["init"] = "init";
    EMakeBetStatus["loading"] = "loading";
    EMakeBetStatus["success"] = "success";
    EMakeBetStatus["error"] = "error";
})(EMakeBetStatus || (exports.EMakeBetStatus = EMakeBetStatus = {}));
var EBasketHeaderTypes;
(function (EBasketHeaderTypes) {
    EBasketHeaderTypes["Coupon"] = "Coupon";
    EBasketHeaderTypes["History"] = "History";
})(EBasketHeaderTypes || (exports.EBasketHeaderTypes = EBasketHeaderTypes = {}));
var EDisplayType;
(function (EDisplayType) {
    EDisplayType[EDisplayType["TOP"] = 0] = "TOP";
    EDisplayType[EDisplayType["BOTTOM"] = 1] = "BOTTOM";
})(EDisplayType || (exports.EDisplayType = EDisplayType = {}));
var EMobileModalType;
(function (EMobileModalType) {
    EMobileModalType[EMobileModalType["SETTINGS"] = 0] = "SETTINGS";
    EMobileModalType[EMobileModalType["OUTCOMES"] = 1] = "OUTCOMES";
    EMobileModalType[EMobileModalType["CALCULATOR"] = 2] = "CALCULATOR";
    EMobileModalType[EMobileModalType["OFF"] = 3] = "OFF";
    EMobileModalType[EMobileModalType["BONUS_COUPON"] = 4] = "BONUS_COUPON";
})(EMobileModalType || (exports.EMobileModalType = EMobileModalType = {}));
//# sourceMappingURL=types.js.map